import { connect } from 'react-redux';
import { setFilters } from '../../actions/index';
import DataGrid from '../../components/DataGrid/DataGrid';



const mapStateToProps = state => {
    return {
        rowFilter: state.rowFilters,
        ruleSubmitting: state.ruleSubmitting
    }
};

export default connect(
    mapStateToProps,
    { setFilters }
)(DataGrid);


// WEBPACK FOOTER //
// ./src/containers/DataGrid/DataGridContainer.js